<a class="w-100" [ngClass]="{active: menuItem.isActive }" href="{{menuItem.routerLink}}" *ngIf="menuItem.externalLink"
  target="_blank"> {{menuItem.title}} </a>
<a class="w-100" [ngClass]="{active: menuItem.isActive }" [routerLink]="[menuItem.routerLink]"
  *ngIf="!menuItem.externalLink && (!menuItem.params)"> {{menuItem.title}}
  <span class="menu-arrow iconfont iconjiantou_liebiaoxiangyou fs-20" *ngIf="(children>0)"></span>
  <span *ngIf="menuItem.isNew" class="hot-icon"></span>
</a>
<a class="w-100" [ngClass]="{active: menuItem.isActive }" [routerLink]="[menuItem.routerLink]" [queryParams]="menuItem.params"
  *ngIf="!menuItem.externalLink && (menuItem.params)"> {{menuItem.title}}
  <span class="menu-arrow iconfont iconjiantou_liebiaoxiangyou fs-20" *ngIf="(children>0)"></span>
  <span *ngIf="menuItem.isNew" class="hot-icon"></span>
</a>